































































/* eslint-disable no-unused-vars */
import _ from 'lodash';
import { listFactory } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { PageMode } from '@/main/utils/pageMode';
import { Row, getColumnsRowMapObject, Cell, ObjectType, convertToObjects } from '@/main/utils/table';
import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { TABLE_DATA, ERROR } from '@/main/store/listEditTypes';
import { isNotNull } from '@/main/utils/isNotNull';
import { NAME as NdObjednavkaName } from '@/modules/sklad/ndObjednavka/constants';
import { apiProvider as ndObjednavkaProvider } from '@/modules/sklad/ndObjednavka/api';
import { HromadnaObjednavka } from '@/modules/sklad/ndObjednavka/store/types';
import { deleteButton } from '@/main/utils/tableOperations';
import ZakazkaSelect from '@/modules/servis/zakazka/components/Select.vue';
import { isRouteEvent, RouteEvent } from '@/main/pages/page';
import { showAlert } from '@/main/utils/notifications';
import { apiProvider as apiProviderReserveParts } from '@/modules/servis/rezervaceND/api';

import { isUserPartsManager, OpenPartMaintenance } from '@/main/utils/commonFunctions';

import { NAME, JFND_ZPRACREZIM_PZN, Mio, GRID_COLUMNS, PARTS_ISSUED } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';
import { NahradniDily } from '../zakazka/nahradniDily';
import { NahradyFilter, UseNahradaInput } from './store/list/types';
import { ZAKAZKA_ND } from '../constants';
import { apiProvider } from './api';
import { RezervaceND } from '../rezervaceND';

export default listFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
		ZakazkaSelect,
	},
	data() {
		return {
			showDialog: {
				visible: false,
				title: null as string | null,
				extraButtons: null as object | null,
				handleClose: () => {},
			},
			fileList: [] as any[],
			gridCols: GRID_COLUMNS,
		};
	},
	computed: {
		isUserPartsManager(): boolean {
			return isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
		},
		isDisabledButtons() {
			return !this.table.rows.length;
		},
		extraButtons(): {} {
			return deleteButton(this.deleteItem);
		},
		zakzkaFilter() {
			return {
				ZakazkaNr: this.localState.dialog.ZakazkaIdNr,
				VyrazenPrp: false,
				PripravaPrp: true,
				OtevrenePrp: true,
			};
		},
		mutationsMappers() {
			return {
				pracovnik: `${this.storeUri}/${listMutations.PRACOVNIK_SELECT_MAPPER}`,
				zakazka: `${this.storeUri}/${listMutations.ZAKAZKA_SELECT_MAPPER}`,
			};
		},
		isCekatNaObjVisible() {
			return [JFND_ZPRACREZIM_PZN.HROMADNY_VYDEJ, JFND_ZPRACREZIM_PZN.HROMADNY_VYDEJ_S_NAHRADOU].includes(this.JfndZpracrezimPzn);
		},
		shouldCheckResult() {
			return this.odpisResult && this.odpisResult!.length > 0 && this.editFormName;
		},
		selectedRowId() {
			return this.selectedNdRow ? this.selectedNdRow[0] : null;
		},
		tableListeners(): {} {
			return {
				sideBarSelectRow: this.sideBarSelectRow,
				'save-column-setting': this.saveColumnSetting,
				selectedRow: this.selectedRow,
				'update:multipleSelection': this.handleSelection,
				currentChange: this.loadNahrady,
			};
		},
		tableModel(): {} {
			return {
				table: this.table,
				sideBarLoading: this.sideBarLoading,
				'multiple-selection': this.multipleSelection,
				'extra-buttons': this.extraButtons,
				'select-row': this.selectedRowId,
				'hyperlink-column': this.isUserPartsManager ? this.gridCols.ND_NR_PLUS : undefined,
			};
		},
	},
	beforeDestroy() {
		const previousPage = this.pageMgrPage;
		if (previousPage && previousPage.name === 'ZakazkaEdit' && this.modulesToRemove?.some((page) => page.name === this.$options.name)) {
			const { ZakazkaId } = this.$store.state.pages[previousPage.storeModule!].edit;
			this.$store.dispatch(`pages/${previousPage.storeModule}/${ZAKAZKA_ND}_${TABLE_DATA}`, { filter: { ZakazkaId } });
		}
	},
	created() {
		this.checkSelectedRow();
		if (this.shouldCheckResult) {
			this.checkResult();
		}
	},
	watch: {
		ZakazkoKratitPrp() {
			this.jfndZpracrezimPznChange(this.JfndZpracrezimPzn);
		},
	},
	methods: {
		OpenPartMaintenance,
		async submitUpload() {
			this.startLoading();
			const { data: partsInfo } = await apiProvider.uploadParts(this.fileList[0], this.ZakazkaId);
			this.fileList = [];
			if (partsInfo) {
				showAlert({
					message: partsInfo,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			}
			this.showDialog.visible = false;
			await this.tableData();
			this.endLoading();
		},
		async handleClose() {
			if (this.table.isModified()) {
				if (await this.getConfirmationForModifiedTable()) {
					this.closeClick();
				}
			} else {
				this.closeClick();
			}
		},
		handleChange(file: Record<string, any>) {
			this.fileList = [file];
		},
		handleRemove(file: File, fileList: []) {
			this.fileList = fileList;
		},
		showUploadPartsClick() {
			this.showDialog.visible = true;
		},
		async deleteItem(e: any, cells: any) {
			const servicePkgId = cells[this.table.cellNames!.SERVICE_PACKAGE_ID];
			if (this.dmsSys.ServicePackagePrp) {
				if ( servicePkgId !== null && servicePkgId > 0) {
					showAlert({
						message: this.LocalizeChyboveHlasky('SERVICE_PACKAGE_DELETE'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
				}
			}
			this.refreshPreviousPage = true;
			this.startLoading();
			const zaznamRwids = [cells[this.table.cellNames!.ZAZNAM_RWID]];
			const zakazkaId = this.ZakazkaId!;
			const reserveQuantity:number[] = [];
			const availableQuantity:number[] = [];
			const reservationIds = [cells[this.table.cellNames!.REZERVACE_ID]];
			const partNumbers = [cells[this.table.cellNames!.ND_NR]];
			const partExtOdpisIds = [cells[this.table.cellNames!.ZAKAZNDEXTODPIS_ID]];
			await apiProvider.deleteEntitys({ zakazkaId, zaznamRwids, reserveQuantity, availableQuantity, reservationIds, partNumbers, partExtOdpisIds});

			this.refreshTable();
			this.endLoading();
		},
		async loadData() {
			this.startLoading();
			await this.loadFilter();
			this.setFilterByParams();

			const schema = await this.schema();
			if(schema.message !== undefined)
			{
				return;	
			}

			await this.nahradyTableSchema();

			this.autoLoadItems
				&& this.tableData().then(() => {
					this.jfndZpracrezimPznChange(this.JfndZpracrezimPzn);
				});
			if (this.props.filter.VozidloId) {
				const { data: vozidlo } = await Vozidlo.apiProvider.getVozidlo(this.props.filter.VozidloId);
				this.VyrobekvozOzn = vozidlo.VyrobekvozOzn;
			}
			this.endLoading();
		},
		async refreshTable() {
			await this.tableData();
			const idIndex = this.table.cellNames!.idColumn;
			this.multipleSelection = _.intersectionWith(this.table.rows, this.multipleSelection, (a, b) => a.cells[idIndex] === b.cells[idIndex]);
			this.reloadTableSelection();
		},
		refreshFun() {
			this.refreshTable();
		},
		createClickFun() {
			this.refreshPreviousPage = true;
			openEdit(
				// Remove the ending 'List' from component name.
				this.$options.name?.slice(0, -4) ?? '',
				PageMode.CREATE,
				{ props: true, filter: { ...this.props.filter, ...this.filter } },
			);
		},
		pracovnikMapper({ data }: { data: { value: number; text: string } }) {
			this.PracovnikId = data.value;
			this.PracovnikIdText = data.text;
		},

		// #region Objednavka
		async onRychlaObjClick() {
			this.objednavkaOptins = { mioPzn: Mio.RychlaObjednavka, ZakazkaId: this.ZakazkaId, kratitPrp: this.ZakazkoKratitPrp };
			await this.openObjednavku();
		},
		async onSkladObjNaZakazkuClick() {
			this.objednavkaOptins = { mioPzn: Mio.SkladovaObjednavka, ZakazkaId: this.ZakazkaId, kratitPrp: this.ZakazkoKratitPrp };
			await this.openObjednavku();
		},
		async onSkladObjNaSkladClick() {
			this.objednavkaOptins = { mioPzn: Mio.SkladovaObjednavka, ZakazkaId: null, kratitPrp: this.organizace.SkoKratitPrp! };
			await this.openObjednavku();
		},
		mapToObjednavkaDTO(row: any, options: { mioPzn: number; ZakazkaId: number | null; kratitPrp: boolean }): HromadnaObjednavka {
			return {
				MioPzn: options.mioPzn,
				MnozstviObj: row.PocetNd - row.MnozstviVyd - (options.kratitPrp ? row.DispStav : 0),
				NdNr: row.NdNr,
				SkladOzn: row.SkladOzn ?? this.SkladOzn,
				VyrobekndOzn: row.VyrobekndOzn ?? this.VyrobekndOzn,
				ZakazkaId: options.ZakazkaId,
				ZakazkandextodpisId: options.ZakazkaId ? row.ZakazndextodpisId : null,
				HromadnaObjednavkaRowId: row.ZaznamRwid,
			};
		},
		async openObjednavku() {
			if (this.JfndZpracrezimPzn === JFND_ZPRACREZIM_PZN.HROMADNA_OBJEDNAVKA) {
				const converterInput = { rows: this.multipleSelection as Row[], columns: this.table.columns };
				const objednat = convertToObjects(converterInput)
					.filter((row: any) => row.PocetNd - row.MnozstviVyd - (this.objednavkaOptins.kratitPrp ? row.DispStav : 0) > 0)
					.map((row: any) => this.mapToObjednavkaDTO(row, this.objednavkaOptins));

				const { data: objednavkaResults } = await ndObjednavkaProvider.hromadnaObjednavka(objednat);
				this.odpisResult = objednavkaResults;
				this.editFormName = NdObjednavkaName;
				this.checkResult();
			} else {
				const row = this.selectedNdRow ?? this.table.rows[0].cells;
				const ndForObjednavku = getColumnsRowMapObject(this.table.columns, row, ObjectType.propertyName);
				const objednat = this.mapToObjednavkaDTO(ndForObjednavku, this.objednavkaOptins);

				openEdit(NdObjednavkaName, PageMode.CREATE, { jfnd: objednat });
			}
		},
		// #endregion Objednavka

		// #region Rezervace
		async onRezervaceClick() {
			this.startLoading();
			try {
				if (this.JfndZpracrezimPzn !== JFND_ZPRACREZIM_PZN.HROMADNA_REZERVACE) {
					if (!this.selectedNdRow) {
						this.selectedNdRow = this.table.rows[0].cells;
					}

					isNotNull(this.selectedNdRow);

					if (!this.selectedNdRow[this.table!.cellNames!.REZERV_UMOZNIT_PRP]) {
						this.showErrorAlert({ message: 'NelzeRezervovat1' });
						return;
					}

					const ndForRezervace = getColumnsRowMapObject(this.table.columns, this.selectedNdRow, ObjectType.propertyName);
					openEdit(RezervaceND.name, PageMode.CREATE, {
						jfnd: { row: { ...ndForRezervace, ZakazkandextodpisId: ndForRezervace.ID }, options: this.filter },
					});
				} else {
					const ndForRezervace = convertToObjects({ rows: this.multipleSelection, columns: this.table.columns });
					if (ndForRezervace.length) {
						const { data: rezervaceResults } = await apiProvider.rezervaceNd({ Rows: ndForRezervace, Options: this.filter });
						this.odpisResult = rezervaceResults;
					}
					this.editFormName = RezervaceND.name;
					this.checkResult();
				}
			} finally {
				this.endLoading();
			}
		},
		// #endregion

		// #region vydej
		async onVydejClick() {
            const StartTime = performance.now();
			await this.vydej();
            let iTotalTimeTaken = performance.now() - StartTime;
            let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await apiProviderReserveParts.logPerformance('OrderPrp','Reservation', PARTS_ISSUED, seconds);
		},
		async vydej() {
			if (this.dmsSys.WorkItemPrp!) {
				this.startLoading();
				const { data: isOrderComplete } = await apiProvider.isOrderComplete(this.ZakazkaId);
				this.endLoading();
				if (isOrderComplete) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('IsAllItemCompleted') });
				}
			}

			this.startLoading();
			try {
				let forVydej = null;
				let showIssueMessage = false;
				let questionResult = false;
				if (this.JfndZpracrezimPzn === JFND_ZPRACREZIM_PZN.HROMADNY_VYDEJ || this.JfndZpracrezimPzn === JFND_ZPRACREZIM_PZN.HROMADNY_VYDEJ_S_NAHRADOU) {
					const ndForVydej = convertToObjects({ rows: this.multipleSelection, columns: this.table.columns });
					const rowsForVydej = ndForVydej.map((row: any) => row);
					forVydej = { Rows: rowsForVydej, Options: this.filter };
					if (forVydej?.Rows.length) {
						this.startLoading();
						await apiProviderReserveParts.createSRForm(forVydej);
						this.endLoading();
						forVydej.Rows.map(async (row: any) => {
                            if (row.PocetNd > row.DispStav) {
								showIssueMessage = true;                            
                            }							
                        });
						if (showIssueMessage) {
							questionResult = await this.showConfirm({
								title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
								message: this.LocalizeChyboveHlasky('issuedPartRemainingPart'),
								options: {
									confirmButtonText: this.Localize('Ano'),
									cancelButtonText: this.Localize('Ne'),
								},
							});
						}
						this.startLoading();
						const { data: isPartInvoice } = await apiProvider.isAnyPartInvoice(forVydej);
						this.endLoading();
						if (isPartInvoice) {
							showAlert({
								message: this.LocalizeChyboveHlasky('INVOICED_PART_REMAINING_PARTS'),
								title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
								options: {
									type: 'info',
								},
							});
						}
						if (showIssueMessage === false) {
							const { data: vydejResults } = await apiProvider.odpisNd(forVydej);
							await apiProvider.uploadMovement(forVydej);
							//await this.deleteClick(false);
							this.odpisResult = vydejResults;
							this.editFormName = NahradniDily.name;
							await this.checkResult();
						} else if (questionResult && showIssueMessage) {
							forVydej.Rows = forVydej.Rows.filter((x)=> x.DispStav > 0);
							const { data: vydejResults } = await apiProvider.odpisNd(forVydej);
                            await apiProvider.uploadMovement(forVydej);
							//await this.deleteClick(false);
							this.odpisResult = vydejResults;
							this.editFormName = NahradniDily.name;
							await this.checkResult();
						}
						
					}
				} else {
					showAlert({
						message: this.LocalizeChyboveHlasky('PART_ISSUE_NOT_ALLOWED'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					this.refreshTable();
					return;
				}
			} catch (err) {
				this.$store.dispatch(ERROR, { err }, { root: true });
			} finally {
				this.refreshPreviousPage = true;
				this.endLoading();
			}
		},
		// #endregion

		async checkResult() {
			if (this.shouldCheckResult) {
				try {
					this.startLoading();
					const vydejRowId = this.odpisResult!.pop();
					if (_.isNil(vydejRowId)) return;
					showAlert({
						message: vydejRowId,
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					this.refreshTable();
				} finally {
					this.endLoading();
				}
			} else {
				this.editFormName = null;
				await this.refreshTable();
			}
		},

		handleSelection(rows: Row[]) {
			this.multipleSelection = rows;
		},
		reloadTableSelection() {
			this.$refs.table && (this.$refs.table as any).reloadSelection();
		},
		async skladOznChange(value: number) {
			this.SkladOzn = value;
			await this.tableData();
			this.reloadTableSelection();
		},
		jfndZpracrezimPznChange(value: number) {
			this.JfndZpracrezimPzn = value;
			switch (value) {
				case JFND_ZPRACREZIM_PZN.AKTUALNE_VYBRANY_ND:
					break;
				case JFND_ZPRACREZIM_PZN.HROMADNA_OBJEDNAVKA:
					this.oznacHromadnuObj();
					break;
				case JFND_ZPRACREZIM_PZN.HROMADNY_VYDEJ:
				case JFND_ZPRACREZIM_PZN.HROMADNY_VYDEJ_S_NAHRADOU:
					this.ozancHromadnyVydej();
					break;
				case JFND_ZPRACREZIM_PZN.HROMADNA_REZERVACE:
					this.oznacHromadRezar();
					break;
				default:
			}
			this.reloadTableSelection();
		},
		getNahradyFilter(cells: Cell[]): NahradyFilter {
			const rowObject = getColumnsRowMapObject(this.table.columns, cells, ObjectType.propertyName) as any;
			return {
				NdNr: rowObject.NdNr,
				VyrobekndOzn: rowObject.VyrobekndOzn,
				NahradaPrp: true,
				ShodaPrp: true,
				JfndSpeczpracrezimPzn: rowObject.JfndSpeczpracrezimPzn,
				SkladOzn: rowObject.SkladOzn,
				ZakazkaId: rowObject.ZakazkaId,
			};
		},
		async loadNahrady(cells: Cell[]) {
			this.selectedNdRow = cells;
			const nahradyFilter = this.getNahradyFilter(cells);
			this.nahradyTableData({ nahradyFilter });
		},
		async useNahradu(cells: Cell[]) {
			const ZakazkandJednotnaFrontaNahrada = getColumnsRowMapObject(this.nahradyTable.columns, cells, ObjectType.propertyName);
			const Zakazkandextodpis = getColumnsRowMapObject(this.table.columns, this.selectedNdRow!, ObjectType.propertyName);

			const useNahrada = {
				Zakazkandextodpis,
				ZakazkandJednotnaFrontaNahrada,
			} as UseNahradaInput;
			this.startLoading();
			await apiProvider.useNahrada(useNahrada);
			await this.tableData();
			this.nahradyTable.rows = [];
			this.endLoading();
		},
		dialogCancel() {
			this.dialog.visible = false;
		},
		async dialogOk() {
			this.dialog.visible = false;
			this.startLoading();
			if (this.multipleSelection) {
				const ndForPrevod = convertToObjects({ rows: this.multipleSelection, columns: this.table.columns });
				const rowsForPrevod = ndForPrevod.map((row: any) => row);
				if (!this.dialog.ZakazkaId) {
					this.showConfirm({
						message: this.LocalizeChyboveHlasky('ConfirmPrevodMioNaNdSklad'),
						options: {
							cancelButtonText: this.Localize('cmdStorno'),
							confirmButtonText: this.Localize('Ok'),
							callback: async (action) => {
								if (action === 'confirm') {
									await apiProvider.prevedPolozkyNaZakazku(this.dialog.ZakazkaId, rowsForPrevod);
									await this.refreshTable();
								} else {
									this.dialog.visible = true;
								}
							},
						},
					});
				} else {
					await apiProvider.prevedPolozkyNaZakazku(this.dialog.ZakazkaId, rowsForPrevod);
					await this.refreshTable();
				}
				this.checkSelectedRow();
				this.refreshPreviousPage = true;
			}
			this.endLoading();
		},
		checkSelectedRow() {
			if (this.selectedNdRow) {
				const findRow = (row: Row) => row.cells[this.table.cellNames!.idColumn] === this.selectedNdRow![this.table.cellNames!.idColumn];
				const existsSelected = this.table.rows.length !== 0 && this.table.rows.some(findRow);
				if (!existsSelected) {
					this.selectedNdRow = null;
					this.nahradyTable.rows = [];
				}
			}
		},
		async deleteClick(refreshDataflag: boolean) {
			try {
				this.startLoading();
				const idIndex: number = this.table.cellNames!.ZAZNAM_RWID;
				const reserveQuantityId: number = this.table.cellNames!.POCET_ND;
				const availableQuantityId: number = this.table.cellNames!.DISP_STAV;
				const reservationIdIndex: number = this.table.cellNames!.REZERVACE_ID;
				const partNumberIndex: number = this.table.cellNames!.ND_NR;
				const partExtOdpisIdIndex: number = this.table.cellNames!.ZAKAZNDEXTODPIS_ID;
				const zaznamRwids = this.multipleSelection.map((row) => row.cells[idIndex]);
				const reserveQuantity = this.multipleSelection.map((row) => row.cells[reserveQuantityId]);
				const availableQuantity = this.multipleSelection.map((row) => row.cells[availableQuantityId]);
				const reservationIds = this.multipleSelection.map((row) => row.cells[reservationIdIndex]);
				const partNumbers = this.multipleSelection.map((row) => row.cells[partNumberIndex]);
				const partExtOdpisIds = this.multipleSelection.map((row) => row.cells[partExtOdpisIdIndex]);
				const zakazkaId = this.ZakazkaId!;
				await apiProvider.deleteEntitys({ zakazkaId, zaznamRwids, reserveQuantity, availableQuantity, reservationIds,
					partNumbers, partExtOdpisIds
				  });
			} catch (error) {
				this.logError(error);
			} finally {
				if (refreshDataflag){
					await this.refreshTable();
				}
				this.refreshPreviousPage = true;
				this.endLoading();
			}
		},
		async beforeUnload(event: BeforeUnloadEvent | RouteEvent | null) {
			await this.doBeforeUload(event);
			if (isRouteEvent(event)) {
				const goNext = !this.shouldRemoveFromPageManager(event.to) || (await this.confirmPageLeave());
				goNext && (await this.handleRemovingFromPageManager(event.to));
				event.next(goNext ? undefined : false);
			}
		},

		async confirmPageLeave() {
			const STATUS_INDEX = 2;
			const visiblePageLeaveConfirm = !!this.table.rows.find((row) => row.cells[STATUS_INDEX] === null);
			if (visiblePageLeaveConfirm) {
				return this.showConfirm({
					message: this.Localize('JFNDNezpracPol'),
					title: this.LocalizeChyboveHlasky('questionTitle'),
					options: {
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
					},
				});
			}
			return true;
		},
	},
});
